import { CSSProperties, FC, useMemo } from 'react';

import { Typography } from '@beeline/design-system-react/extracted-styles';

import { Room } from 'src/types';

import classes from './RoomPlace.module.scss';

export interface RoomPlaceProps {
  item: Room;
}

export const RoomPlace: FC<RoomPlaceProps> = ({ item }) => {
  const { width, height, fontSize } = item;

  const x = item.x - width / 2;
  const y = item.y - height / 2;

  const containerStyle = useMemo(
    (): CSSProperties => ({
      transform: `translate(${x}px,${y}px)`,
      width: `${width}px`,
      height: `${height}px`,
    }),
    [height, width, x, y],
  );
  const fontSizePx = `${fontSize}px`;
  const titleStyle = useMemo(
    (): CSSProperties => ({
      fontSize: fontSizePx,
      lineHeight: fontSizePx,
    }),
    [fontSizePx],
  );

  return (
    <div className={classes.container} style={containerStyle}>
      <Typography
        variant='subtitle3'
        className={classes.title}
        style={titleStyle}
      >
        {item.title}
      </Typography>
    </div>
  );
};
